export var SingerErrorLogConstants;
(function (SingerErrorLogConstants) {
    SingerErrorLogConstants["TapErrorStartMarker"] = "[tap_error_start]";
    SingerErrorLogConstants["TapErrorEndMarker"] = "[tap_error_end]";
    SingerErrorLogConstants["TapErrorFileName"] = "tapError.json";
    SingerErrorLogConstants["TargetErrorStartMarker"] = "[target_error_start]";
    SingerErrorLogConstants["TargetErrorEndMarker"] = "[target_error_end]";
    SingerErrorLogConstants["TargetErrorFileName"] = "targetError.json";
})(SingerErrorLogConstants || (SingerErrorLogConstants = {}));
//# sourceMappingURL=singerErrorLogContants.js.map